/**
 * メッセージクラス
 */
export class Message {
  constructor(
    _level: "INFO" | "WARN" | "ERROR",
    _id: string,
    _message: string
  ) {
    return {
      level: _level,
      id: _id,
      message: _message,
    };
  }

  /**
   * 種別
   */
  level: "INFO" | "WARN" | "ERROR";

  /**
   * ID
   */
  id: string;

  /**
   * 内容
   */
  message: string;
}
